export const isLoading = state => state.adminReducer.studentTypes.isLoading

export const isSuccess = state => state.adminReducer.studentTypes.isSuccess

export const studentTypes = state => state.adminReducer.studentTypes.types
